var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskInspectionRope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.984 8.6V6.584h-1.968V8.6zm0 8.016v-6h-1.968v6zm-.984-15q2.736 0 5.064 1.368a9.46 9.46 0 0 1 3.552 3.552 9.8 9.8 0 0 1 1.368 5.064 9.8 9.8 0 0 1-1.368 5.064 9.46 9.46 0 0 1-3.552 3.552A9.8 9.8 0 0 1 12 21.584a9.8 9.8 0 0 1-5.064-1.368 9.64 9.64 0 0 1-3.552-3.576 9.8 9.8 0 0 1-1.368-5.04q0-2.712 1.368-5.04A9.8 9.8 0 0 1 6.96 2.984 9.8 9.8 0 0 1 12 1.616"
})));
export default SvgTaskInspectionRope;